export default async function fetchStorefrontApi(storefrontApiAccessToken, query, variables = {}) {
  if (!storefrontApiAccessToken) {
    // eslint-disable-next-line no-console
    console.error('Storefront API access token is not set');
    return null;
  }

  const endpoint = `https://${window.Shopify.shop}/api/2024-10/graphql.json`;
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontApiAccessToken,
    },
    body: JSON.stringify({ query, variables }),
  });

  const { data, errors } = await response.json();

  if (errors) {
    throw new Error(errors[0].message);
  }

  return data;
}
